/**
 * @generated SignedSource<<063fb623e0198797247765e1e017650f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceSettingsQuery$variables = {
  piece_id: string;
};
export type PieceSettingsQuery$data = {
  readonly music_viewer: {
    readonly piece: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"PieceSettingsBody_piece">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"PieceSettingsBody_viewer">;
  };
};
export type PieceSettingsQuery = {
  variables: PieceSettingsQuery$variables;
  response: PieceSettingsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "piece_id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "piece_id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PieceSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicViewer",
        "kind": "LinkedField",
        "name": "music_viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PieceSettingsBody_viewer"
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PieceSettingsBody_piece"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PieceSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicViewer",
        "kind": "LinkedField",
        "name": "music_viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "is_employee",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "end_to_end_test_file_download_url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MusicPieceFile",
                "kind": "LinkedField",
                "name": "file",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tempo",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e2a2fa4c33115be23a8c44d3ce86482b",
    "id": null,
    "metadata": {},
    "name": "PieceSettingsQuery",
    "operationKind": "query",
    "text": "query PieceSettingsQuery(\n  $piece_id: ID!\n) {\n  music_viewer {\n    ...PieceSettingsBody_viewer\n    piece(id: $piece_id) {\n      id\n      ...PieceSettingsBody_piece\n    }\n  }\n}\n\nfragment PieceSettingsBodyEmployeeOnlySection_piece on MusicPiece {\n  id\n  end_to_end_test_file_download_url\n}\n\nfragment PieceSettingsBody_piece on MusicPiece {\n  id\n  name\n  ...PieceSettingsNameItem_Piece\n  ...PieceSettingsBodyEmployeeOnlySection_piece\n  ...PieceSettingsTempoItem_piece\n}\n\nfragment PieceSettingsBody_viewer on MusicViewer {\n  me {\n    is_employee\n    id\n  }\n}\n\nfragment PieceSettingsNameItem_Piece on MusicPiece {\n  id\n  name\n}\n\nfragment PieceSettingsTempoItem_piece on MusicPiece {\n  id\n  file {\n    tempo\n  }\n}\n"
  }
};
})();

(node as any).hash = "efc0f2670dfcc5b0e10ede14032ad2b9";

export default node;
